// src/services/orders.service.js
import { http } from '../lib/http';
import { getUser } from '../lib/authToken';
import { DEV_USER } from "../config/localAuth";

export function fetchOrders({
  orgId,
  location,
  start_date,
  end_date,
  status = 'paid',
  page = 1,
  pageSize = 10,
  sort = 'date_desc',
  q = ''
}) {
  const user = getUser() || DEV_USER;
  orgId = orgId || user.restaurant_id;
  location = location || user.location;

  const qs = new URLSearchParams({
    orgId,
    location,
    status,
    page: String(page),
    pageSize: String(pageSize),
    sort,
    q
  });

  // Add date filters if provided
  if (start_date) {
    qs.append('start_date', start_date);
  }
  if (end_date) {
    qs.append('end_date', end_date);
  }

  // Decode colons that were URL-encoded by URLSearchParams
  const queryString = qs.toString().replace(/%3A/g, ':');
  return http.get(`/fe/orders/l1?${queryString}`);
}

export function fetchOrderDetail(orderId, orgId, location) {
  const user = getUser() || DEV_USER;
  orgId = orgId || user.restaurant_id;
  location = location || user.location;
  return http.get(`/fe/orders/l2/${orderId}?orgId=${orgId}&location=${location}`);
}

// Live order operations
// Extract numeric ID from order ID (e.g., "ORD0001" -> "1", "2" -> "2")
function extractOrderId(orderId) {
  if (!orderId) return null;
  const str = String(orderId);
  // If it's already a number, return it
  if (/^\d+$/.test(str)) return str;
  // If it has "ORD" prefix, extract the number
  const match = str.match(/(\d+)$/);
  return match ? match[1] : str;
}

export function acceptOrder(orderId) {
  const id = extractOrderId(orderId);
  if (!id) throw new Error("Invalid order ID");
  return http.post(`/fe/orders/${id}/accept`);
}

export function declineOrder(orderId) {
  const id = extractOrderId(orderId);
  if (!id) throw new Error("Invalid order ID");
  return http.post(`/fe/orders/${id}/decline`);
}

export function deliverOrder(orderId) {
  const id = extractOrderId(orderId);
  if (!id) throw new Error("Invalid order ID");
  return http.post(`/fe/orders/${id}/deliver`);
}

// Reveal customer phone number after password verification
export function revealPhone(restaurant_id, order_no, location, password) {
  return http.post(`/fe/orders/reveal-phone`, {
    restaurant_id,
    order_no,
    location,
    password
  });
}
